import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DespachoColaboradoresReportDialogData {
    coordinador: string;
    year: number;
    medicoId: number | null;
    medicoNombre: string;
}

export interface DespachoColaboradoresReportDialogResult {
    scope: 'medico' | 'coordinador';
    dateFrom: Date;
    dateTo: Date;
}

@Component({
    selector: 'app-despacho-colaboradores-report-popup',
    templateUrl: './despacho-colaboradores-report-popup.component.html',
    styleUrls: ['./despacho-colaboradores-report-popup.component.scss'],
    standalone: false,
})
export class DespachoColaboradoresReportPopupComponent {
    scope: 'medico' | 'coordinador';
    dateFrom: Date;
    dateTo: Date;
    validationMessage: string = '';

    constructor(
        private dialogRef: MatDialogRef<DespachoColaboradoresReportPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DespachoColaboradoresReportDialogData
    ) {
        this.scope = data.medicoId ? 'medico' : 'coordinador';
        this.dateFrom = new Date(data.year, 0, 1);
        this.dateTo = new Date(data.year, 11, 31);
    }

    get medicoDisponible(): boolean {
        return !!this.data.medicoId;
    }

    cancelar(): void {
        this.dialogRef.close();
    }

    aceptar(): void {
        this.validationMessage = '';

        if (!this.dateFrom || !this.dateTo) {
            this.validationMessage = 'Debe indicar ambas fechas.';
            return;
        }

        if (this.dateFrom > this.dateTo) {
            this.validationMessage = 'La fecha inicial no puede ser posterior a la final.';
            return;
        }

        if (this.scope === 'medico' && !this.medicoDisponible) {
            this.validationMessage = 'Debe seleccionar un medico.';
            return;
        }

        this.dialogRef.close({
            scope: this.scope,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
        } as DespachoColaboradoresReportDialogResult);
    }
}
